module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "comp-navbar-e"
  }, [_c('el-popover', {
    ref: "messageBox",
    attrs: {
      "placement": "bottom",
      "width": "350",
      "trigger": "click",
      "disabled": !_vm.unreadMessageInfo.totalCount
    },
    model: {
      value: (_vm.messageVisible),
      callback: function($$v) {
        _vm.messageVisible = $$v
      },
      expression: "messageVisible"
    }
  }, [_c('div', {
    staticClass: "message-box"
  }, [_c('p', {
    staticClass: "mc-title"
  }, [_vm._v("消息中心")]), _vm._v(" "), _c('ul', _vm._l((_vm.unreadMessageInfo.data), function(message) {
    return _c('li', [_c('a', {
      staticClass: "message-title",
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.showDetail(message)
        }
      }
    }, [_vm._v(_vm._s(message.title.length > 23 ? message.title.slice(0, 22) + '...' :
      message.title))]), _vm._v(" "), _c('img', {
      staticClass: "message-icon",
      attrs: {
        "src": _vm.icon_new,
        "alt": "mew"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(message.publish_time))])])
  })), _vm._v(" "), _c('p', {
    staticClass: "mc-footer",
    on: {
      "click": _vm.showMoreMessages
    }
  }, [_vm._v("查看更多")])])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "nav-logo",
    attrs: {
      "src": _vm.logoUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "service"
  }, [_vm._v("商户中心")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "sub-header-menu"
  }, _vm._l((_vm.sysMenus), function(sys) {
    return _c('div', {
      staticClass: "system-item",
      class: sys.code === _vm.activeMenu ? 'active' : ''
    }, [_c('a', {
      attrs: {
        "href": sys.url
      }
    }, [_vm._v("\n            " + _vm._s(sys.name) + "\n          ")])])
  }))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('ul', {
    staticClass: "account-area"
  }, [_c('li', {
    directives: [{
      name: "popover",
      rawName: "v-popover:messageBox",
      arg: "messageBox"
    }],
    staticClass: "message",
    on: {
      "click": _vm.goToMsgCenter
    }
  }, [_vm._v("\n          消息\n          "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unreadMessageInfo.totalCount),
      expression: "unreadMessageInfo.totalCount"
    }],
    staticClass: "message-count"
  }, [_vm._v(_vm._s(_vm.unreadMessageInfo.totalCount))])]), _vm._v(" "), _c('li', {
    staticClass: "x-line"
  }), _vm._v(" "), _c('li', {
    staticClass: "restaurant",
    attrs: {
      "title": _vm.userInfo.belongName
    }
  }, [_vm._v("\n          " + _vm._s(_vm.userInfo.belongName) + "\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "x-line"
  }), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "username"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("欢迎你，" + _vm._s(_vm.userInfo.realName || _vm.userInfo.username))]), _vm._v(" "), (_vm.userInfo.weekPasswork && _vm.userInfo.userType === 0) ? _c('img', {
    staticClass: "guide-pwd",
    attrs: {
      "src": _vm.guide_pwd_02
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.isDemoUser) ? _c('el-dropdown-item', {
    attrs: {
      "command": "userInfo"
    }
  }, [_vm._v("用户信息")]) : _vm._e(), _vm._v(" "), (_vm.isDemoUser) ? _c('el-dropdown-item', {
    attrs: {
      "command": "changePwd"
    }
  }, [_vm._v("\n                  修改密码\n                  "), (_vm.userInfo.weekPasswork && _vm.userInfo.userType === 0) ? _c('img', {
    staticClass: "guide-pwd",
    staticStyle: {
      "width": "14px",
      "height": "14px"
    },
    attrs: {
      "src": _vm.guide_pwd_01
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isDemoUser) ? _c('el-dropdown-item', {
    attrs: {
      "command": "changePhone"
    }
  }, [_vm._v("绑定手机号")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', [_vm._v("退出系统")])], 1)], 1)], 1)])])])], 1), _vm._v(" "), _c('messageDialog', {
    ref: "m_dialog",
    on: {
      "close": _vm.closeDialog
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogInfo.title,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dialogLoading),
      expression: "dialogLoading"
    }]
  }, [_c('iframe', {
    attrs: {
      "src": _vm.dialogInfo.url,
      "frameborder": "0",
      "width": "100%",
      "height": _vm.dialogInfo.height
    },
    on: {
      "load": _vm.dialogLoaded
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02f4f8b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/NavBar/NavBarCRM.vue
// module id = 174
// module chunks = 0